import { Api } from "@open-revenue/schema/api-schema";
import { StripeApi } from "@open-revenue/stripe/schema";
import { PaddleApi } from "@open-revenue/paddle/schema";
export const OpenRevenueApi = Api.add(StripeApi.StripeApi).add(PaddleApi).prefix("/open-revenue/dash-api");
